import * as React from 'react'
import styled, { css } from 'styled-components'

import * as ds from '@bob/design-system'
import * as utils from '@boutique/utils'

export type TileData = {
  title: string
  svg: string
}

export const Tile = React.memo(function MemoizedTile({
  isFocused,
  onFocus,
  title,
  svg,
}: {
  isFocused: boolean
  onFocus: () => void
} & TileData): React.ReactElement {
  const Icon = (ds.illustrations.criteria as any)[utils.symbols.getCriterionSymbolName(svg)]

  return (
    <Li isFocused={isFocused}>
      <Wrapper>
        <Block onClick={() => onFocus()}>
          <Icon />
          <ds.styles.heading.TitleTab>{title}</ds.styles.heading.TitleTab>
        </Block>
      </Wrapper>
    </Li>
  )
})

const Wrapper = styled.div`
  position: absolute;
  top: 43%;
  width: 100%;

  @media screen and (${ds.breakpoint.TABLET}) {
    top: 35%;
  }
`

const Block = styled.div`
  cursor: pointer;
  transition-duration: 250ms;
`

const Li = styled.li<{ isFocused: boolean }>`
  bottom: 0px;
  display: inline-flex;
  height: 350px;
  position: relative;
  scroll-snap-align: center;
  top: 0px;
  transition-duration: 100ms;
  width: 100%;
  z-index: 1;

  ${({ isFocused }) =>
    isFocused &&
    css`
      color: white;
      ${Block} {
        transform: scale(2);
      }
    `}

  @media screen and (${ds.breakpoint.TABLET}) {
    height: 100%;
    width: 255px;

    ${({ isFocused }) =>
      isFocused &&
      css`
        pointer-events: none;
      `}
  }

  ${ds.illustrations.Illustration} {
    display: block;
    margin: auto;
  }

  ${ds.styles.heading.TitleTab} {
    max-width: 140px;
    margin: 0 auto;
    text-align: center;
    white-space: normal;
  }

  /* code for Safari Desktop & Mobile */
  @media not all and (min-resolution: 0.001dpcm) {
    @media {
      transition-duration: 0ms;
      ${Block} {
        transition-duration: 0ms;
      }
    }
  }
`
